import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EfsBaseService } from './efs-base.service';
import { AppFavorites } from '../dto/app-favorite.dto';
import { SurveySubmission } from '../dto/survey-submission.dto';
import { Survey } from '../dto/survey.dto';
import { EfsUserBaseService } from './efs-user-base.service';
import { TogetherLoginDto } from '../dto/togethe-login.dto';

@Injectable({ providedIn: 'root' })
export class UserApiService extends EfsUserBaseService {

  getMyAvatar(): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl(`users/my-avatar`),
      undefined,
    );
    return uOb;
  }

  launchTogetherLogin(): Observable<TogetherLoginDto> {
    const uOb = this.query<TogetherLoginDto>(
      this.http,
      this.apiUrl(`users/launch-together-login`),
      undefined,
    );
    return uOb;
  }

  getMyManagers(): Observable<any> {
    const uOb = this.query<{
      cn: string,
      displayName: string,
      sn: string,
      givenName: string,
      mail: string,
      careerTitle: string,
    }[]>(
      this.http,
      this.apiUrl(`users/my-managers`),
      undefined,
    );
    return uOb;
  }

  getMyDirectManager(): Observable<{
    cn: string,
    displayName: string,
    sn: string,
    givenName: string,
    mail: string,
    careerTitle: string,
  }> {
    const uOb = this.query<{
      cn: string,
      displayName: string,
      sn: string,
      givenName: string,
      mail: string,
      careerTitle: string,
    }>(
      this.http,
      this.apiUrl(`users/my-direct-manager`),
      undefined,
    );
    return uOb;
  }
}
